import { BadgeCheck, CalendarCheck, Coffee, ParkingCircle, TrainFront } from "lucide-react";
import { useLang } from "@/i18n/LangContext";
import { Container } from "@/components/common";
import { Stagger, Item } from "@/components/motion/Reveal";

const ICONS = [BadgeCheck, CalendarCheck, Coffee, ParkingCircle, TrainFront];

export function Attributes() {
  const { t } = useLang();
  return (
    <div data-testid="brand-attributes" className="bg-sand pt-16 pb-6 md:pt-24 md:pb-10">
      <Container>
        <Stagger className="grid grid-cols-2 md:grid-cols-5 gap-y-10 gap-x-6 border-t border-line pt-10">
          {t.attrs.map((a, i) => {
            const Icon = ICONS[i];
            return (
              <Item key={a.t} className="flex flex-col gap-3">
                <Icon size={20} strokeWidth={1.25} className="text-terra" />
                <div>
                  <p className="text-sm font-medium text-charcoal">{a.t}</p>
                  <p className="mt-1 font-mono text-[10px] uppercase tracking-[0.18em] text-charcoal/50">{a.d}</p>
                </div>
              </Item>
            );
          })}
        </Stagger>
      </Container>
    </div>
  );
}
